import { TextField } from '@consta/uikit/TextField'
import { VALID_RESULT } from 'common/constants'
import type { ValidationResult } from 'common/types'
import { forwardRef } from 'react'

import type { UseBooleanFlagApi } from '../../../../hooks'
import type { OnEndCallback } from '../DialogModal'
import { DialogModal } from '../DialogModal'
import { validateName } from './helpers'
import css from './RenameModal.css'

type RenameModalProps = {
  handleRename: (newName: string) => void
  onEnd: VoidFunction
  initialValue?: string
  label?: string
  extraValidate?: (value: unknown) => ValidationResult
}

export const RenameModal = forwardRef<UseBooleanFlagApi, RenameModalProps>(function RenameModal(
  { onEnd, handleRename, initialValue, label, extraValidate = () => VALID_RESULT },
  ref,
) {
  const handleEnd: OnEndCallback = ({ performAction, value }) => {
    if (performAction && typeof value === 'string') {
      handleRename(value)
    }

    onEnd()
  }

  const validateFields = (value: unknown): ValidationResult =>
    validateName(value).isValid ? extraValidate(value) : validateName(value)

  return (
    <DialogModal
      ref={ref}
      className={css.renameModal}
      submitLabel="Сохранить"
      cancelLabel="Отмена"
      initialValue={initialValue}
      validateFields={validateFields}
      onEnd={handleEnd}>
      {(value, setValue) => {
        const validationResult = validateFields(value)

        return (
          <TextField
            value={typeof value === 'string' ? value : ''}
            size="xs"
            label={label}
            labelPosition="top"
            caption={validationResult.isValid ? undefined : validationResult.errText}
            onChange={setValue}
          />
        )
      }}
    </DialogModal>
  )
})
